import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux'
import {Form, Text} from 'react-form';
import {validateEmail} from "../utils/api"
import {login} from "../redux/actions/user"

interface LoginProps {
  login: typeof login;
}

class LoginState {
  loading: boolean;
  error: string;
  emailValid: boolean;
  password: string;
  passwordValid: boolean;
  email: string;
  enableLogin: boolean;
}

class LoginContainer extends Component < LoginProps,
LoginState > {
  emailRef = null;
  passwordRef = null;
  componentWillMount() {
    this.setState({
      loading: null,
      error: null,
      emailValid: null,
      password: "",
      passwordValid: null,
      email: null,
      enableLogin: null
    });
    document.body.classList.add('seaBlue');
  }
  componentDidMount() {
    this._listener = setInterval(() => {
      if (this.emailRef && this.passwordRef) {
        let email = this.emailRef.value
        let password = this.passwordRef.value
        if (email.length > 0) {
          this.emailChange(email);
        }
        if (password.length > 0) {
          this.passwordChange(password);
        }
      }
    }, 20);
  }
  componentWillUnmount() {
    document.body.classList.remove('seaBlue')
    clearInterval(this._listener);
  }
  emailChange(value) {
    let valid = validateEmail(value)
    if (this.emailValid !== valid) {
      this.setState({emailValid: valid})
    }
    this.setState({email: value})
    this.checkValidation()
  }
  passwordChange(password) {
    this.setState({
      password,
      passwordValid: password.length > 0
    })
    this.checkValidation()
  }
  checkValidation() {
    const {emailValid, passwordValid} = this.state;
    this.setState({
      enableLogin: (passwordValid && emailValid)
    })
  }
  signIn = (e) => {
    e.preventDefault();
    const {email, password} = this.state;
    this.props.login(email, password)
  }
  render() {
    const {error} = this.state;
    return (<div className={"container"}>
      <div className="auth-holder">
        <h1>Sign In</h1>
        <Form render={({signIn}) => (<form className="deep-purple-text lighten-1" onSubmit={this.signIn}>
            <div className="row inputs">
              <div className="input-field col s12">
                <input type="email" onChange={this.emailChange.bind(this)} ref={node => this.emailRef = node}/>
                <label htmlFor="title">Email</label>
                {
                  (this.state.emailValid !== null && !this.state.emailValid) && <p className="error">
                      Not A Valid Email
                    </p>
                }
              </div>
              <div className="input-field col s12">
                <input type="password" onChange={this.passwordChange.bind(this)} ref={node => this.passwordRef = node}/>
                <label htmlFor="title">Password</label>
                {
                  (this.state.passwordValid !== null && !this.state.passwordValid) && <p className="error">
                      Required
                    </p>
                }
              </div>
            </div>
            <p className="center">
              <button type="submit" disabled={!this.state.enableLogin} className={"deep-purple lighten-1 btn" + (
                  this.state.loading
                  ? " loading"
                  : "")}>
                <span className="inline">Log In</span>
                {this.state.loading && <img alt={"img"} className="spin inline" src="/loading.png"/>}
              </button>
            </p>
            {error !== null && <p>{error}</p>}
          </form>)}/>
      </div>
    </ div>);
  }
}

export default connect(null, {login})(LoginContainer)



// WEBPACK FOOTER //
// ./src/Component/Login.js